import Box from "ds/components/Box";
import ComboBoxHighlightText from "ds/components/ComboBox/HighlightText";
import ListBoxItem from "ds/components/ListBox/Item";
import CheckboxIcon from "ds/components/Toggle/CheckboxIcon";
import Typography from "ds/components/Typography";
import Badge from "ds/components/Badge";

import { IDP_GROUP_MAPPING_URL } from "./constants";

type ManagedUserGroupComboBoxItemProps = {
  id: string;
  label: string;
  isSelected?: boolean;
  isInputValueItem?: boolean;
  isEmptyValue?: boolean;
  isUnmapped?: boolean;
};

const ManagedUserGroupComboBoxItem = ({
  id,
  label,
  isSelected,
  isInputValueItem,
  isEmptyValue,
  isUnmapped,
}: ManagedUserGroupComboBoxItemProps) => {
  if (isEmptyValue) {
    return (
      <ListBoxItem
        href={IDP_GROUP_MAPPING_URL}
        target="_blank"
        textValue={id}
        aria-describedby={`${id}-description`}
      >
        <Typography tag="span" variant="p-body3" color="primary">
          No options available. Create new{" "}
          <Typography tag="span" variant="p-body3" color="interactive">
            group mapping
          </Typography>
        </Typography>
      </ListBoxItem>
    );
  }

  if (isInputValueItem) {
    return (
      <ListBoxItem
        href={IDP_GROUP_MAPPING_URL}
        target="_blank"
        textValue={id}
        aria-describedby={`${id}-description`}
      >
        <Typography tag="span" variant="p-body3" color="primary">
          Can't find? Create new{" "}
          <Typography tag="span" variant="p-body3" color="interactive">
            group mapping.
          </Typography>
        </Typography>
      </ListBoxItem>
    );
  }

  return (
    <ListBoxItem id={id} textValue={label} aria-describedby={`${id}-description`}>
      <Box gap="medium" fullWidth>
        <CheckboxIcon isSelected={isSelected} />
        <Box direction="column" gap="small" justify="center" align="start" fullWidth>
          <Box gap="small" align="center" justify="between" fullWidth>
            <ComboBoxHighlightText text={label} />
            {isUnmapped && <Badge variant="yellow" type="strong" text="Unmapped" />}
          </Box>
        </Box>
      </Box>
    </ListBoxItem>
  );
};

export default ManagedUserGroupComboBoxItem;
